export { default as Icon } from './icon';
export { default as Form } from './form';
export { default as Mention } from './mention';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/compatible/es/index.js
// module id = 4571
// module chunks = 1